import { render } from "./RecordUploadView.vue?vue&type=template&id=4b55ba5e&scoped=true"
import script from "./RecordUploadView.vue?vue&type=script&lang=js"
export * from "./RecordUploadView.vue?vue&type=script&lang=js"

import "./RecordUploadView.vue?vue&type=style&index=0&id=4b55ba5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b55ba5e"]])

export default __exports__